<template>
    <div>

    </div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        mounted(){
            this.$router.push('/home');
        }
    }
</script>